// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/supply_bilateral_trade_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SupplyBilateralTradeService } from "./supply_bilateral_trade_service_pb";

/**
 * ListBilateralTrades returns all bilateral trades matching the given
 * filters together with aggregated summary, optional monthly grouping,
 * and the eSL sync status.
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.ListBilateralTrades
 */
export const listBilateralTrades = SupplyBilateralTradeService.method.listBilateralTrades;

/**
 * GetBilateralTradeRecap returns the full Recap detail of a single bilateral
 * trade.
 * Separate from ListBilateralTrades because the list intentionally omits
 * unit price, total amount, and supply hours (see parent issue §5).
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.GetBilateralTradeRecap
 */
export const getBilateralTradeRecap = SupplyBilateralTradeService.method.getBilateralTradeRecap;

/**
 * DeleteBilateralTrade deletes a manually-entered bilateral trade.
 * expected_updated_at enables optimistic locking; the backend returns
 * ABORTED when the row has been modified since the client last fetched it.
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.DeleteBilateralTrade
 */
export const deleteBilateralTrade = SupplyBilateralTradeService.method.deleteBilateralTrade;

/**
 * CreateBilateralTrade registers a new manually-entered bilateral trade.
 * organization_id is resolved from the eauth session (not exposed to frontend).
 * Returns the full BilateralTrade for immediate UI reflection.
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.CreateBilateralTrade
 */
export const createBilateralTrade = SupplyBilateralTradeService.method.createBilateralTrade;

/**
 * UpdateBilateralTrade updates a manually-entered bilateral trade.
 * organization_id is resolved from the eauth session.
 * expected_updated_at enables optimistic locking; the backend returns
 * ABORTED when the row has been modified since the client last fetched it.
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.UpdateBilateralTrade
 */
export const updateBilateralTrade = SupplyBilateralTradeService.method.updateBilateralTrade;

/**
 * GetBilateralTrade returns the full BilateralTrade for the given id.
 * organization_id is resolved from the eauth session.
 * Used to populate the edit form with all current field values.
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.GetBilateralTrade
 */
export const getBilateralTrade = SupplyBilateralTradeService.method.getBilateralTrade;

/**
 * CheckBilateralTradeCsv parses and validates the 契約マスタ CSV and returns
 * the 5-state row diff preview plus a check_token (引換券). No persistent
 * side-effect on trading_contract. organization_id / acting_member_id are
 * resolved from the eauth session (not exposed to frontend).
 *
 * 旧 ImportBilateralTrades (all-or-nothing 単発 RPC) を置換した 2 段 API の
 * 前段。Mirrors internalapi.v1 CheckBilateralTradeCsv。
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.CheckBilateralTradeCsv
 */
export const checkBilateralTradeCsv = SupplyBilateralTradeService.method.checkBilateralTradeCsv;

/**
 * ApplyBilateralTradeCsv exchanges a valid check_token for the actual
 * 差分 upsert + 48 点再展開 (1 transaction)。エラー行が 1 件でもある
 * check_token は全体拒否される。
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.ApplyBilateralTradeCsv
 */
export const applyBilateralTradeCsv = SupplyBilateralTradeService.method.applyBilateralTradeCsv;

/**
 * ExportBilateralTrades は入稿済みの相対取引契約を CSV 行 (1 行 = 1 leg) と
 * して全量返す (uploads/common.md §6 AC-DUC-028/029)。絞り込みは持たない。
 * Mirrors internalapi.v1 ExportBilateralTrades。
 *
 * @generated from rpc bffuser.v1.SupplyBilateralTradeService.ExportBilateralTrades
 */
export const exportBilateralTrades = SupplyBilateralTradeService.method.exportBilateralTrades;
